<script>
    export let isActive;
    export let align;
    let _class = "";
    export { _class as class };
</script>

<button
    class={`button-wrapper ${_class} ${isActive ? "is-active" : ""} ${
        align !== undefined ? align : ""
    }`}
    on:click
    {...$$restProps}
>
    <div>
        <slot />
    </div>
</button>

<style lang="scss">
    button.left > div {
        justify-content: flex-start;
    }
    button > div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
